import { render, staticRenderFns } from "./Recherches.vue?vue&type=template&id=54eb03e4"
import script from "./Recherches.vue?vue&type=script&lang=js"
export * from "./Recherches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports